import { useMemo } from "react";
const COLOR = {
  off: '#1fdb8a',
  on: '#fff',
  disabled: '#444',
}

type Props = {
  theme?: keyof typeof COLOR;
  size?: number;
};

export const TrimmingIcon = ({ theme = 'off', size = 20 }: Props) => {
  const color = useMemo(() => COLOR[theme], [theme]);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.99 20.99" width={size} height={size}>
      <g id="レイヤー_2" data-name="レイヤー 2">
        <g id="レイヤー_1-2" data-name="レイヤー 1">
          <path
            fill={color}
            d="M17.49,15.74V3.5H5.25V0H3.5V3.5H0V5.25H3.5V17.49H15.74V21h1.75v-3.5H21V15.74Zm-1.75,0H5.25V5.25H15.74Z"
          />
          <polygon
            fill={color}
            points="9.76 13.97 14.78 8.96 13.51 7.69 9.76 11.43 7.48 9.16 6.21 10.43 8.49 12.7 9.76 13.97"
          />
        </g>
      </g>
    </svg>
  );
  };
